import script from "./tk.vue?vue&type=script&setup=true&lang=js"
export * from "./tk.vue?vue&type=script&setup=true&lang=js"

import "./tk.vue?vue&type=style&index=0&id=eaaac888&lang=scss"

const __exports__ = script;

export default __exports__